import { api } from '@forbiz/web-kit'
import type { ConfirmPaymentRequest, CreatePaymentResponse, PaymentView } from '@forbiz/contracts'

/**
 * 선불 결제 API 클라이언트 (BIZ-70/78).
 * 생성은 멱등(살아있는 결제가 있으면 그대로 반환), 금액은 서버가 스냅샷에서 재계산해 확정한다.
 */
export const paymentsApi = {
  create: (orderId: number) => api.post<CreatePaymentResponse>(`/api/orders/${orderId}/payments`, {}),
  confirm: (body: ConfirmPaymentRequest) => api.post<{ payment: PaymentView }>('/api/payments/confirm', body),
}
